import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ component: Component, allowedRoles, ...rest }) => {
  const token = localStorage.getItem("token");
  const isSuperAdmin = localStorage.getItem("is_superadmin") === "1"; // Verifica si es SuperAdmin

  if (!token) {
    return <Navigate to="/login" />;
  }

  // Redirigir si el rol no está permitido
  if (allowedRoles) {
    if (allowedRoles.includes("superadmin") && !isSuperAdmin) {
      return <Navigate to="/dashboard" />;
    }

    if (allowedRoles.includes("cliente") && isSuperAdmin) {
      return <Navigate to="/super-admin" />;
    }
  }

  return <Component {...rest} />;
};

export default PrivateRoute;
